<app-svg-definitions></app-svg-definitions>
<ng-content>
    
</ng-content>
<h2 class="p-2 mt-3" *ngIf="investment" [style.background-color]="bgColor" [style.color]="color">Asset Allocation:</h2>
<!-- <code><pre>
{{data|json}}
</pre></code> -->
<table class="table table-hover" *ngIf="data && data.length>0">
    <thead><tr>
        <th colspan="2" *ngIf="missing.length==0">IFA Indexes* (Click name for definition)</th>
         <th colspan="2" *ngIf="missing.length>0">Name</th>
        <th class="text-end">Allocation (%)</th>
        <th class="text-end">Number of Stocks & Bonds*</th>
        <!-- <th class="text-end">Wtd Avg Mkt Cap (in $ Mill)*</th> -->
        <!-- <th class="text-end">Wtd Avg Book to Market*</th> -->
        <th class="text-end">Price to Book*</th>        
        <!-- <th>As Of Date</th> -->
    </tr></thead>
    <tbody>
        <tr *ngFor="let r of data">
            <td *ngIf="r.name.startsWith('IFA')">
               
                <app-svg-sprite  
               
                [routerLink]="['/disclosures/index-data/']" [fragment]="r.symbol"
                hash="{{'#icon-'+r.lowersymbol+''}}"
                [width]=26 
                [height]=26 
                style="" 
                [title]="r.name"
                ></app-svg-sprite>               
               
            </td>
            <td [colSpan]="r.name.startsWith('IFA')?1:2">
                @if(r.name.startsWith('IFA')){
                    <a [routerLink]="['/disclosures/index-data/']" [fragment]="r.symbol">{{r.name}}</a>
                }
                @else{
                   {{r.symbol}} - {{r.name}}
                }
            </td>
            <td class="text-end">{{r.percent}}%</td>
            <td class="text-end"><a [href]="r.holdingsheet">{{r.number_of_holdings|number}}</a></td>
            <!-- <td class="text-end"><a [href]="r.factsheet">{{r.weighted_avg_market_cap==null?'N/A':r.weighted_avg_market_cap|currency:'$': 'symbol' : '1.0-0'}}</a></td> -->
            <td class="text-end">{{ r.price_to_book != null ? (r.price_to_book | number:'0.2-2') : 'N/A'}}</td>
            <!-- <td class="text-end">{{r.date|date:'M/d/yyyy'}}</td> -->
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <td colspan="2">* As of {{data[0].date|date:'MMMM d, yyyy'}}</td>
            <td class="text-end">{{totalPercent|number:'1.0-0'}}%</td>
            <td class="text-end">{{totalHoldings|number}}</td>
            <!-- <td class="text-end" title="Weighted Value">{{avgMktCap|currency:'$': 'symbol' : '1.0-0'}}</td> -->
            <td class="text-end" title="Weighted Value">{{priceToBook|number:'0.2-2'}}</td>
        </tr>
    </tfoot>
</table>